export default __webpack_public_path__ + "static/media/blinking-blocks.6c43be95.gif";